import React from "react";
import { Helmet } from "react-helmet-async";

export default function Privacys() {
  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Privacy Policy | Fuzz</title>
        <meta
          name="description"
          content="Read Fuzz's Privacy Policy to understand how we collect, use, and protect your personal data, location data, and contact information."
        />
        <link
          rel="canonical"
          href="https://fuzzpreview.myzow.in/privacy"
        />
      </Helmet>

      <section className="py-24 bg-white min-h-screen">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">

            {/* Header */}
            <div className="mb-16">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Privacy Policy
              </h1>
              <p className="text-gray-600 text-lg">
                Effective Date: 1st July 2025
              </p>
              <p className="text-gray-600">
                Entity: Fuzzapp Solutions Private Limited
              </p>
            </div>

            <div className="space-y-12 text-gray-700 leading-relaxed text-base">

              {/* Section 1 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  1. Introduction
                </h2>
                <p>
                  This Privacy Policy outlines how Fuzzapp Solutions Private Limited
                  ("Fuzz," "we," "our," or "us") collects, uses, shares, and safeguards
                  your personal data when you use our website (https://fuzzapp.io),
                  mobile application ("App"), or associated services.
                </p>
                <p className="mt-4">
                  By using our platform, you consent to the practices described in this policy.
                  Fuzz is committed to protecting your privacy in accordance with applicable
                  laws including the Information Technology Act, 2000 (India), GDPR, and CCPA.
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  2. Data We Collect
                </h2>

                <h3 className="font-semibold text-gray-900 mt-6 mb-2">
                  a) Information You Provide
                </h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Name, email, mobile number</li>
                  <li>Demographic details (age, gender identity, preferences)</li>
                  <li>Profile photos and bio</li>
                  <li>Feedback and support inquiries</li>
                  <li>Messages and chats within the app</li>
                </ul>

                <h3 className="font-semibold text-gray-900 mt-6 mb-2">
                  b) Automatically Collected Data
                </h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>IP address, device ID, OS type</li>
                  <li>App usage patterns and logs</li>
                  <li>Crash reports and diagnostics</li>
                  <li>Hashed contact numbers (if permission granted)</li>
                  <li>Precise GPS location (foreground & background)</li>
                </ul>

                <h3 className="font-semibold text-gray-900 mt-6 mb-2">
                  c) Third-Party Sources
                </h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>App stores</li>
                  <li>Analytics services (Google Analytics, Firebase)</li>
                  <li>Social login providers</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  3. Use of Personal Data
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide and improve services</li>
                  <li>Facilitate location-based matchmaking</li>
                  <li>Ensure safety and prevent abuse</li>
                  <li>Process subscriptions and payments</li>
                  <li>Run analytics and monitor performance</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  4. Sharing of Data
                </h2>
                <p>We do not sell your personal information.</p>
                <ul className="list-disc pl-6 mt-4 space-y-2">
                  <li>Hosting & analytics vendors</li>
                  <li>Payment processors (Razorpay, Apple/Google Pay)</li>
                  <li>Legal authorities when required</li>
                  <li>Corporate successors (if applicable)</li>
                  <li>Other users (only when you opt to share)</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  5. Purpose of Contacts & Location Data
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Identify which contacts are on Fuzz</li>
                  <li>Help you discover nearby friends</li>
                  <li>Generate movement insights</li>
                  <li>Improve app performance</li>
                </ul>
                <p className="mt-4">
                  This data is encrypted and never shared with third-party advertisers.
                </p>
              </div>

              {/* Additional Policies */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  6–13. Additional Policies
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Location permissions can be managed in device settings.</li>
                  <li>Data retained while account is active (or up to 12 months inactive).</li>
                  <li>Cookies & SDKs used for analytics and performance.</li>
                  <li>No collection of data from individuals under 18.</li>
                  <li>You may request access, correction, or deletion of your data.</li>
                  <li>We use SSL encryption and secure cloud storage.</li>
                  <li>International transfers follow SCC safeguards.</li>
                  <li>Policy updates will be communicated via app/email.</li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  14. Grievance Redressal & Contact
                </h2>
                <p>Grievance Email: grievance@fuzzapp.io</p>
                <p>Support: support@fuzzapp.io</p>
                <p className="mt-4">
                  Registered Office: 10th Flr, Nesco Tower 4, C WING,
                  Western Express Highway, Goregaon East,
                  Mumbai - 400063, Maharashtra, India
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}